export const BASE_URI = "https://ecommerce-backend-zrl1.onrender.com";
// export const BASE_URI = "http://localhost:4000";
